import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "@phosphor-icons/react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { LogoMark } from "@/components/site/Logo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user !== true) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-primary grain flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="relative z-10 w-full max-w-md">
        <a href="/" className="inline-flex items-center gap-2 text-white/70 hover:text-white text-sm mb-6 transition-colors" data-testid="back-home-link">
          <ArrowLeft size={16} /> Back to site
        </a>
        <div className="rounded-3xl bg-background border border-border p-8 md:p-10 shadow-2xl">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-11 h-11 rounded-xl bg-white flex items-center justify-center border border-border">
              <LogoMark className="w-7 h-7" gradient />
            </div>
            <div>
              <p className="font-heading text-xl text-primary leading-none">Explus Admin</p>
              <p className="text-xs text-muted-foreground mt-1">Quote requests dashboard</p>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-5" data-testid="login-form">
            <div>
              <Label htmlFor="email" className="text-sm font-semibold text-primary mb-2 block">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@expluscleaning.com" className="h-12" data-testid="login-email" />
            </div>
            <div>
              <Label htmlFor="password" className="text-sm font-semibold text-primary mb-2 block">Password</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="h-12" data-testid="login-password" />
            </div>
            <button type="submit" disabled={loading} className="w-full rounded-full bg-primary text-primary-foreground font-semibold py-3.5 hover:-translate-y-0.5 hover:shadow-lg transition-all disabled:opacity-60" data-testid="login-submit">
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
